export enum RecordType {
    Video = 1,
    Audio = 2,
    Subtitle = 3
}

export const mapToRecordType = (type: number): RecordType => {
    if (type in RecordType) {
        return type as RecordType;
    }

    throw Error(`Unrecognized RecordType: ${type}`);
};

export const mapNumberToRecordType = (typeNumber: number): RecordType => {
    if (isNumberRecordType(typeNumber)) {
        return typeNumber;
    }

    throw new Error("Incorrect RecordType");
};

const isNumberRecordType = (typeNumber: number) => {
    const recordTypes = [RecordType.Video, RecordType.Audio, RecordType.Subtitle];

    return recordTypes.some((record: RecordType) => record === typeNumber);
};
